export enum TipoUsuario {
	Corretora = 1,
	Tomador = 2,
	EscritorioAdvocacia = 3,
	Advogado = 4,
	BMG = 5,
	Outros = 6,
	API = 7,
	Assessoria = 8
}
